// import indianNumberFormatComponent from "@/common/helpers/indianNumberFormatComponent";

// export const commonColumns1 = ({ handleActionChange, actionOptions, 
//   } = {}) => {

//   const valFinder = (obj) => {
//     console.log('valFinder-obj', obj)

    
//     if (typeof JSON.parse(obj) === 'object' && obj !== null) {
//       const data = JSON.parse(obj)
//       // Convert values to numbers and sum them
//       const total = Object.values(data).reduce((sum, val) => {
//         const num = parseFloat(val);
//         return sum + (isNaN(num) ? 0 : num);
//       }, 0);

//       console.log(total,'valFinder-total'); // Output 
//       if( total && total > 0){
//         return indianNumberFormatComponent(total)
//       }
//       return total
//     } else {
//       return indianNumberFormatComponent(obj)
//     } 
//   }

//   const vadDataUpdate = (original, input) => {
//     return input === undefined ? original : input    
//   }

//   // const targetFinder = (obj) => {
//   //   console.log(obj,'targetFinder-obj')

    
//   //   if (typeof JSON.parse(obj) === 'object' && obj !== null) {
//   //     const data = JSON.parse(obj)
//   //     // Convert values to numbers and sum them
//   //     const total = Object.values(data).reduce((sum, val) => {
//   //       const num = parseFloat(val);
//   //       return sum + (isNaN(num) ? 0 : num);
//   //     }, 0);

//   //     console.log(total,'targetFinder-total'); // Output 
//   //     if( total && total > 0){
//   //       return indianNumberFormatComponent(total)
//   //     }
//   //     return total
//   //   } else {
//   //     return indianNumberFormatComponent(obj)
//   //   } 
//   // }

//   const targetFinder = (obj) => {
//     console.log(obj, 'targetFinder-obj');

//     // 1. Check if obj is null, undefined, or empty
//     if (!obj) return 0;

//     // 2. If it's already an object (not a string), process it directly
//     if (typeof obj === 'object') {
//       const total = Object.values(obj).reduce((sum, val) => {
//         const num = parseFloat(val);
//         return sum + (isNaN(num) ? 0 : num);
//       }, 0);
//       return total > 0 ? indianNumberFormatComponent(total) : total;
//     }

//     // 3. If it's a string, try to parse it safely
//     try {
//       // Only attempt to parse if it looks like a JSON string
//       if (typeof obj === 'string' && (obj.startsWith('{') || obj.startsWith('['))) {
//         const data = JSON.parse(obj);
//         const total = Object.values(data).reduce((sum, val) => {
//           const num = parseFloat(val);
//           return sum + (isNaN(num) ? 0 : num);
//         }, 0);
//         return total > 0 ? indianNumberFormatComponent(total) : total;
//       }
//     } catch (e) {
//       console.error("JSON Parsing failed", e);
//     }

//     // 4. Fallback: If it's just a plain number or non-JSON string
//     return indianNumberFormatComponent(obj);
//   }
//   const boxStyle = {
//     display: 'inline-block',
//     width: '24px',
//     height: '24px',
//     backgroundColor: '#4caf50', // Green
//     color: 'white',
//     fontWeight: 'bold',
//     borderRadius: '6px', // Rounded corners
//     textAlign: 'center',
//     lineHeight: '24px', // Vertically center the check
//     fontSize: '16px',
//     userSelect: 'none'
//   };

//   const columns = [
  
//     {
//       header: 's-no',
//       accessorKey: 'id',
//       cell: ({ row }) => {
//         const plantId = row.index + 1;
//         console.log('plantId', plantId)
//         return plantId;
//       }
//     },
//     {
//       header: 'customer',
//       accessorKey: 'customerName',
//        cell: ({ row }) => {
//         let plantId1 = `${row.original.customerName} - (${row.original.customerCode})`;
//         return plantId1;
//       }
//     },
  
//     // {
//     //   header: 'target',
//     //  // accessorKey: 'targetMts',
//     //   // cell: ({ row }) => {
//     //   //   let plantId1 = targetFinder(row.original.targetMts);
//     //   //   return plantId1;
//     //   // }
//     //    cell: ({ row }) => {
//     //           const min = parseFloat(row.original.minMts || 0);
//     //           const max = parseFloat(row.original.maxMts || 0);
//     //           const target = parseFloat(row.original.targetMts || 0);
      
//     //           if (min && max) {
//     //             return (
//     //               <div style={{ textAlign: "right", fontWeight: 600 }}>
//     //                 {indianNumberFormatComponent(min)} –{" "}
//     //                 {indianNumberFormatComponent(max)}
//     //               </div>
//     //             );
//     //           }
      
//     //           return indianNumberFormatComponent(target);
//     //         },
//     // },

//     {
//       header: 'target',
//       accessorKey: 'targetMts', // Keep this for sorting/filtering
//       cell: ({ row }) => {
//         // 1. Helper to safely parse numbers even if the value is an object or string
//         const getVal = (val) => {
//           if (typeof val === 'object' && val !== null) {
//             // If it's the sales/target object, sum the values
//             return Object.values(val).reduce((sum, v) => sum + (parseFloat(v) || 0), 0);
//           }
//           return parseFloat(val) || 0;
//         };

//         const min = getVal(row.original.minMts);
//         const max = getVal(row.original.maxMts);
//         const target = getVal(row.original.targetMts);

//         // 2. Logic for rendering Slab Range (Min - Max)
//         if (min > 0 && max > 0) {
//           return (
//             <div style={{ textAlign: "left", fontWeight: 600 }}>
//               {indianNumberFormatComponent(min)} – {indianNumberFormatComponent(max)}
//             </div>
//           );
//         }

//         // 3. Fallback to Target (Fixed: Ensure it returns 0 if target is 0)
//         return (
//           <div style={{ textAlign: "left" }}>
//             {indianNumberFormatComponent(target)}
//           </div>
//         );
//       },
//     },
//     {
//       header: 'sales',
//       accessorKey: 'monthSales',
    
//     },
    
//   ];

//   if (handleActionChange && actionOptions) {
//     columns.push(
//       {
//         header: 'avg-sales',
//         accessorKey: 'avgSales', 
       
//       },
//       {
//         header: 'avg-rule',
//         accessorKey: 'avgRuleInfo', 
       
//       }
      
//     );
//   }


//   return columns;
// }

// export const anotherColumns = ({ ...rest}) =>  ([

//   {
//     id: 'select',
  
//   },
//   ...commonColumns1(rest)
// ]);

// export const initialValues = {
   
//   activeStatus: 1,
 
// } 

// import indianNumberFormatComponent from "@/common/helpers/indianNumberFormatComponent";
// import Dropdown from "@/common/components/dropdown/dropdown"; 
// import { Grid, Button, Checkbox, Chip } from "@mui/material";
// import TextInput from "@/common/components/text-input/text-input";
// import { border } from "@mui/system";

// export const commonColumns = ({ handleActionChange, actionOptions, handleAvgRuleChange, formik, handleStatusChange, statusOptions, averageRuleOptions, handleButtonClick, avgRule, groupId} = {}) => {

//   const valFinder = (obj) => {
//     console.log('valFinder-obj', obj)

    
//     if (typeof JSON.parse(obj) === 'object' && obj !== null) {
//       const data = JSON.parse(obj)
//       // Convert values to numbers and sum them
//       const total = Object.values(data).reduce((sum, val) => {
//         const num = parseFloat(val);
//         return sum + (isNaN(num) ? 0 : num);
//       }, 0);

//       console.log(total,'valFinder-total'); // Output 
//       if( total && total > 0){
//         return indianNumberFormatComponent(total)
//       }
//       return total
//     } else {
//       return indianNumberFormatComponent(obj)
//     } 
//   }

//   const vadDataUpdate = (original, input) => {
//     return input === undefined ? original : input    
//   }

//   const targetFinder = (obj) => {
//     console.log(obj,'targetFinder-obj')

    
//     if (typeof JSON.parse(obj) === 'object' && obj !== null) {
//       const data = JSON.parse(obj)
//       // Convert values to numbers and sum them
//       const total = Object.values(data).reduce((sum, val) => {
//         const num = parseFloat(val);
//         return sum + (isNaN(num) ? 0 : num);
//       }, 0);

//       console.log(total,'targetFinder-total'); // Output 
//       if( total && total > 0){
//         return indianNumberFormatComponent(total)
//       }
//       return total
//     } else {
//       return indianNumberFormatComponent(obj)
//     } 
//   }

//   const boxStyle = {
//     display: 'inline-block',
//     width: '24px',
//     height: '24px',
//     backgroundColor: '#4caf50', // Green
//     color: 'white',
//     fontWeight: 'bold',
//     borderRadius: '6px', // Rounded corners
//     textAlign: 'center',
//     lineHeight: '24px', // Vertically center the check
//     fontSize: '16px',
//     userSelect: 'none'
//   };

//   const columns = [
//     // {
//     //   id: 'select',
//     //   header: ({ table }) => (
//     //       <Checkbox
//     //           checked={table.getIsAllRowsSelected()}
//     //           indeterminate={table.getIsSomeRowsSelected()}
//     //           onChange={table.getToggleAllPageRowsSelectedHandler()}
//     //       />
//     //   ),
//     //   cell: ({ row }) => {
        
//     //     let target = targetFinder(row.original.targetMts)
//     //     let sales = row.original.monthSales

//     //     if(sales == 0 && target == 0)
//     //     {
//     //       return (<span>⊗</span>)
//     //     } else if(sales < target)
//     //     { return (
//     //       <Checkbox
//     //           checked={row.getIsSelected()}
//     //           disabled={!row.getCanSelect()}
//     //           onChange={row.getToggleSelectedHandler()}
//     //       />)
//     //     } else {
//     //       return (<span style={boxStyle}>✓</span>)
//     //     }
//     //   }
//     // },
//     {
//       header: 's-no',
//       accessorKey: 'id',
//       cell: ({ row }) => {
//         const plantId = row.index + 1;
//         console.log('plantId', plantId)
//         return plantId;
//       }
//     },
//     {
//       header: 'customer',
//       accessorKey: 'customerName',
//        cell: ({ row }) => {
//         let plantId1 = `${row.original.customerName} - (${row.original.customerCode})`;
//         return plantId1;
//       }
//     },
//     // {
//     //   header: 'customer-code',
//     //   accessorKey: 'customerCode'
//     // }, 
//     // {
//     //   header: 'scheme-value',
//     //   accessorKey: 'schemeValue',
//     //   cell: ({ row }) => {
//     //     let plantId = valFinder(row.original.schemeValue)
//     //     // console.log('txtettd')
//     //     // let plantId = value + 234
//     //     return plantId; 
//     //   }
//     // },
//     // {
//     //   header: 'target',
//     //   accessorKey: 'targetMts',
//     //   cell: ({ row }) => {
//     //     let plantId1 = targetFinder(row.original.targetMts);
//     //     return plantId1;
//     //   }
//     // },
//     {
//   header: 'target',
//   accessorKey: 'targetMts', // Keep this for sorting/filtering
//   cell: ({ row }) => {
//     // 1. Helper to safely parse numbers even if the value is an object or string
//     const getVal = (val) => {
//       if (typeof val === 'object' && val !== null) {
//         // If it's the sales/target object, sum the values
//         return Object.values(val).reduce((sum, v) => sum + (parseFloat(v) || 0), 0);
//       }
//       return parseFloat(val) || 0;
//     };

//     const min = getVal(row.original.minMts);
//     const max = getVal(row.original.maxMts);
//     const target = getVal(row.original.targetMts);

//     // 2. Logic for rendering Slab Range (Min - Max)
//     if (min > 0 && max > 0) {
//       return (
//         <div style={{ textAlign: "left", fontWeight: 600 }}>
//           {indianNumberFormatComponent(min)} – {indianNumberFormatComponent(max)}
//         </div>
//       );
//     }

//     // 3. Fallback to Target (Fixed: Ensure it returns 0 if target is 0)
//     return (
//       <div style={{ textAlign: "left" }}>
//         {indianNumberFormatComponent(target)}
//       </div>
//     );
//   },
// },
//     {
//       header: 'sales',
//       accessorKey: 'monthSales',
//       cell: ({ row }) => {
//         let plantId1 = row.original.monthSales ?? 0;
//         return plantId1;
//       }
//     },
//     {
//       header: 'Status',
//       accessorKey: 'schemeStatus',
//       cell: (cell) => {
//         switch (cell.getValue()) {
//           case 2:
//             return <Chip color="error" label="Rejected" size="small" variant="light" />;
//           case 1:
//           default:
//             return <Chip color="success" label="Yet To Decision" size="small" variant="light" />;
//         }
//       }
//       // cell: ({ row }) => {
//       //   let plantId1 = row.original.monthSales ?? 0;
//       //   return plantId1;
//       // }
//     },
    
//   ];

//   // if (handleActionChange && actionOptions) {
//   //   columns.push(
//   //     {
//   //       header: 'average-sales',
//   //       accessorKey: 'avgSales', 
//   //       cell: ({row}) => (  
//   //         <TextInput 
//   //           size="small"
//   //           fullWidth
//   //           value={vadDataUpdate(row.original.avgSales,row.original.avgSales_index)} 
//   //           InputProps={{ readOnly: true }} 
//   //         /> 
//   //       )
//   //     },
//   //     // {
//   //     //   header: 'average-rule',
//   //     //   accessorKey: 'avgRule', 
//   //     //   cell: ({row}) => (  
//   //     //     <Dropdown
//   //     //       size="small"
//   //     //       options={averageRuleOptions}
//   //     //       formik={formik}
//   //     //       style={{ width: '265px', border:  (avgRule && groupId) || row.original.avgRule_index ? "" : '3px solid red' }}
//   //     //       // value={row.original.avgRule_index || ''}
//   //     //       value={vadDataUpdate(row.original.avgRule,row.original.avgRule_index)}
//   //     //       onChange={(e) => { 
//   //     //         handleAvgRuleChange(e,row.original)
//   //     //       }} 
//   //     //     />
//   //     //   )
//   //     // }
      
//   //   );
//   // }

//   // if (handleButtonClick) {
//   //   columns.push({
//   //     header: 'fetch-data',
//   //     cell: ({row}) => (             
//   //       <Button
//   //         variant="contained"
//   //         onClick={() => handleButtonClick(row.original)}
//   //       >
//   //         Get Sales
//   //       </Button>        
//   //     )
//   //   });
//   // }

//   // if (handleStatusChange && statusOptions) {
//     // columns.push({
//     //   header: 'Status',
//     //   accessorKey: 'status',
//     //   cell: ({ row }) => {
//     //     let target = targetFinder(row.original.targetMts)
//     //     let sales = row.original.monthSales
//     //     if(sales == 0 && target == 0)
//     //     {
//     //       return '-'
//     //     }
//     //     if(sales > target)
//     //     {
//     //       return <Chip color="error" label="Eligible" size="small" variant="light" />;
//     //     } else {
//     //       return <Chip color="error" label="Not Eligible" size="small" variant="light" />;
//     //     }
//     //   }     
//     // });
//   // }

//   return columns;
// }

// export const anotherColumns = ({ ...rest}) =>  ([

//   {
//     id: 'select',
  
//   },
//   ...commonColumns(rest)
// ]);

// export const initialValues = {
   
//   activeStatus: 1,
 
// } 

import React from "react";
import indianNumberFormatComponent from "@/common/helpers/indianNumberFormatComponent";
import { Chip } from "@mui/material";

/* -------------------------------- HELPERS -------------------------------- */

const parseValue = (val) => {
  if (val === null || val === undefined) return {};
  if (typeof val === "string") {
    try {
      return JSON.parse(val);
    } catch {
      return parseFloat(val) || {};
    }
  }
  return val || {};
};

const getSum = (obj) => {
  const parsed = parseValue(obj);
  if (typeof parsed !== "object") return parseFloat(parsed) || 0;
  return Object.values(parsed).reduce((sum, v) => sum + (parseFloat(v) || 0), 0);
};

const getCategoryValue = (obj, cat) => {
  const parsed = parseValue(obj);
  if (typeof parsed !== "object") return 0;
  return parseFloat(parsed?.[cat] || 0);
};

const isMaidaEligible = (salesObj = {}, targetObj = {}) => {
  const cats = ["PA", "PB", "BA", "BB", "MUL"];
  return cats.some((cat) => {
    const sales = parseFloat(salesObj?.[cat] || 0);
    const target = parseFloat(targetObj?.[cat] || 0);
    return target > 0 && sales >= target;
  });
};

/* -------------------------------- MAIN -------------------------------- */

export const commonColumns1 = ({
  formik,
  productName,
}) => {
  const baseCategories = ["PA", "PB", "BA", "BB", "MUL", "TOT"];

  const isMaida = String(productName || formik?.values?.schemeName || "").
  toLowerCase().includes("maida");
  const isFeed = String(productName || formik?.values?.schemeName || "").
  toLowerCase().includes("feed");

  const columns = [
    {
      header: "s-no",
      accessorKey: "id",
      cell: ({ row }) => row.index + 1,
    },
    {
      header: "customer",
      accessorKey: "customerName",
      cell: ({ row }) => `${row.original.customerName} - (${row.original.customerCode})`,
    },
  ];

  /* ✅ FEED VIEW */
  if (isFeed) {
    columns.push(
      {
        header: "slab",
        cell: ({ row }) => {
          const from = row.original.achievedSlabFrom || 0;
          const to = row.original.achievedSlabTo || 0;
          return <div style={{ textAlign: "left", fontWeight: 600 }}>{from} - {to}</div>;
        },
      },
      // {
      //   header: "sales",
      //   accessorKey: "monthSales",
      //   cell: ({ row }) => (
      //     <div style={{ textAlign: "left", fontWeight: 600 }}>
      //       {indianNumberFormatComponent(row.original.monthSales || 0)}
      //     </div>
      //   ),
      // },
      {
            header: "sales",
            accessorKey: "monthSales",
            cell: ({ row }) => {
              const from = row.original.achievedSlabFrom || 0;
              const to = row.original.achievedSlabTo || 0;
              const color = (from === 0 && to === 0) ? "red" : "green";
              return (
                <div style={{ textAlign: "center", fontWeight: 600, color }}>
                  {indianNumberFormatComponent(row.original.monthSales || 0)}
                </div>
              );
            },
          },            
      {
        header: "achieved-bags",
        accessorKey: "noOfBags",
        cell: ({ row }) => (
          <div style={{ textAlign: "left" }}>
            {indianNumberFormatComponent(row.original.noOfBags || 0)}
          </div>
        ),
      },
      {
        header: "cost-per-ton",
        accessorKey: "schemeRsPerTon",
        cell: ({ row }) => (
          <div style={{ textAlign: "left" }}>
            {indianNumberFormatComponent(row.original.schemeRsPerTon || 0)}
          </div>
        ),
      }
    );
  }

  /* ✅ MAIDA CATEGORY VIEW */
  if (isMaida) {
    columns.push(
      {
        id: "target_group",
        header: () => <div style={{ textAlign: "left", fontWeight: 700 }}>Target</div>,
        columns: baseCategories.map((cat) => ({
          id: `target-${cat}`,
          header: cat,
          cell: ({ row }) => indianNumberFormatComponent(
            cat === "TOT" ? getSum(row.original.targetMts) : 
            getCategoryValue(row.original.targetMts, cat)
          ),
        })),
      },
      // {
      //   id: "sales_group",
      //   header: () => <div style={{ textAlign: "left", fontWeight: 700 }}>Sales</div>,
      //   columns: baseCategories.map((cat) => ({
      //     id: `sales-${cat}`,
      //     header: cat,
      //     cell: ({ row }) => {
      //       const sales = cat === "TOT" ? getSum(row.original.monthSales) :
      //        getCategoryValue(row.original.monthSales, cat);
      //       const target = cat === "TOT" ? getSum(row.original.targetMts) : 
      //       getCategoryValue(row.original.targetMts, cat);
      //       let color = target === 0 ? "#f9a825" : sales >= target ? "green" : "red";
      //       return <div style={{ textAlign: "left", color, fontWeight: 600 }}>
      //         {indianNumberFormatComponent(sales)}</div>;
      //     },
      //   })),
      // }
       {
              id: "sales_group",
              header: () => <div style={{ textAlign: "Right", fontWeight: 700 }}>Sales</div>,
              columns: baseCategories.map((cat) => ({
                id: `sales-${cat}`,
                header: cat,
                cell: ({ row }) => {
                const sales = cat === "TOT"
                  ? getSum(row.original.monthSales)
                  : getCategoryValue(row.original.monthSales, cat);
                const target = cat === "TOT"
                  ? getSum(row.original.targetMts)
                  : getCategoryValue(row.original.targetMts, cat);
      
                let color = target === 0 ? "#f9a825" : sales >= target ? "green" : "red";
      
                return (
                  <div style={{ textAlign: "right", color, fontWeight: 600 }}>
                    {indianNumberFormatComponent(sales)}
                  </div>
                );
              },
            })),
          },
    );
  }

  /* ✅ NON-MAIDA / NON-FEED VIEW (STANDARD) */
  if (!isMaida && !isFeed) {
    columns.push({
      header: "target",
      cell: ({ row }) => {
        const min = parseFloat(row.original.minMts || 0);
        const max = parseFloat(row.original.maxMts || 0);
        const target = getSum(row.original.targetMts);

        if (min > 0 && max > 0) {
          return (
            <div style={{ textAlign: "left", fontWeight: 600 }}>
              {indianNumberFormatComponent(min)} – {indianNumberFormatComponent(max)}
            </div>
          );
        }
        return <div style={{ textAlign: "left" }}>{indianNumberFormatComponent(target)}</div>;
      },
    });

    columns.push({
      header: "sales",
      cell: ({ row }) => {
        const sales = getSum(row.original.monthSales);
        const target = getSum(row.original.targetMts);
        const min = parseFloat(row.original.minMts || 0);
        const max = parseFloat(row.original.maxMts || 0);
        let color = sales >= (min || target) ? "green" : "red";
        if (!min && !target) color = "#f9a825";

        return (
          <div style={{ textAlign: "left", color, fontWeight: 600 }}>
            {indianNumberFormatComponent(sales)}
          </div>
        );
      },
    });
  }

  /* ✅ STATUS COLUMN */
  columns.push({
    header: "Status",
    accessorKey: "schemeStatus",
    cell: ({ row }) => {
      // If the backend has a fixed status (Rejected/Approved)
      if (row.original.schemeStatus === 2) return 
      <Chip color="error" label="Rejected" size="small" />;
      
      // Calculate Eligibility for display
      const salesObj = parseValue(row.original.monthSales);
      const targetObj = parseValue(row.original.targetMts);
      let eligible = false;

      if (isFeed) {
        eligible = (row.original.achievedSlabFrom || 0) > 0;
      } else if (isMaida) {
        eligible = isMaidaEligible(salesObj, targetObj);
      } else {
        const sales = getSum(salesObj);
        const min = parseFloat(row.original.minMts || 0);
        const target = getSum(targetObj);
        eligible = sales >= (min || target);
      }

      return eligible ? 
        <Chip color="success" label="Eligible" size="small" /> : 
        <Chip color="warning" label="Not Eligible" size="small" />;
    },
  });

  return columns;
};

export const anotherColumns = (props) => [
  { id: "select" },
  ...commonColumns1(props),
];

export const initialValues = {
   
  activeStatus: 1,
 
} 